import {FC} from 'react';
import {Router} from 'router';

const App: FC = () => <Router />;

export default App;
